import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  selected: null,
  touched: false,
  availableBin: '',
  selectedBin: '',
  preSaleBinValid: null,
  selectedCleaned: false,
  showed: false,
  displayedOnce: false,
  showPreSaleBinError: false,
  callSummary: 0,
};

const slice = createSlice({
  name: 'msci',
  initialState: reHydrateStore('msci') || initialState,
  reducers: {
    setMsci: (state, { payload }) => ({ ...state, ...payload }),
    setPaymentPlans: (state, { payload }) => ({ ...state, ...payload }),
    setAvailableBin: (state, { payload }) => ({
      ...state,
      availableBin: payload,
    }),
    setSelectedBin: (state, { payload }) => ({
      ...state,
      selectedBin: payload,
    }),
    setCallSummary: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    setShowed: (state, { payload }) => ({
      ...state,
      showed: payload,
      displayedOnce: true,
    }),
    setPreSaleBinValid: (state, { payload }) => ({
      ...state,
      preSaleBinValid: payload,
    }),
    setPreSaleBinError: (state, { payload }) => ({
      ...state,
      showPreSaleBinError: payload,
    }),
    resetPaymentPlans: (state) => ({
      ...state,
      msiAvailablePlans: null,
      mciAvailablePlans: null,
      defaultPaymentPlan: null,
      selected: null,
      availableBin: '',
      selectedBin: '',
      selectedCleaned: false,
      showed: false,
      touched: false,
    }),
    setSelectedPaymentPlan: (state, { payload }) => ({
      ...state,
      ...payload,
      touched: true,
      selectedCleaned: false,
    }),
    resetSelectedAndClean: (state) => ({
      ...state,
      selected: null,
      selectedCleaned: true,
    }),
    restore: () => initialState,
  },
});

export const {
  setMsci,
  setAvailableBin,
  setSelectedBin,
  setPaymentPlans,
  setPreSaleBinError,
  setShowed,
  setCallSummary,
  setPreSaleBinValid,
  resetPaymentPlans,
  setSelectedPaymentPlan,
  resetSelectedAndClean,
  restore,
} = slice.actions;

export default slice.reducer;

export const selectMsci = (state) => state.msci;
